// extracted by mini-css-extract-plugin
module.exports = {"grid":"experts-carousel_grid__MqQ6f","gridItem":"experts-carousel_gridItem__3psHI","addButton":"experts-carousel_addButton__1nqzO","session":"experts-carousel_session__6BINo"};